import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Every page opened part-way down and had to be scrolled back up.
   React Router does not touch the scroll position when the route changes:
   the browser keeps whatever offset the PREVIOUS page had, and a long list
   followed by a short form lands the reader below the form's title. Nothing in
   the portal reset it, so the offset was inherited on every navigation.

   Reset on the pathname only. Query-string changes (a filter, a page number)
   are the same screen and must not jump the reader to the top of it. A hash
   is left alone too: the browser is about to scroll to that anchor itself. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
